<div class="row">
  <select #selector class="selectpicker col-md-12" (change)='onChange(selector.value)'>
    <option *ngFor="let option of options" [value]="option.value" [selected]="option.value === valueSelected">
      {{ option.name }}
    </option>
  </select>
</div>
